import * as React from 'react';

import { utils } from 'ui-common';
import { WindowWrapper } from 'login-utils/globalWrappers';

import * as loansAPI from 'login-apis/loansAPI';
import FormDialog from '../Common/Form/FormDialog/FormDialog';
import LoadingSpinner from '../Common/LoadingSpinner/LoadingSpinner';
import ErrorMessage from '../Common/Notifications/ErrorMessage/ErrorMessage';
import AppDocumentTitle from '../Common/AppDocumentTitle/AppDocumentTitle';

import './LoanHydration.scss';

interface LoanHydrationState {
  error: string | null;
}

export default class LoanHydration extends React.PureComponent<{}, LoanHydrationState> {
  state = {
    error: null,
  };

  async componentDidMount() {
    try {
      const loanId = utils.cookieUtils.get('selectedProductId');
      await loansAPI.hydrateLoan(loanId);
      WindowWrapper.location.reload();
    } catch (err) {
      this.setState({
        error: 'Failed to fetch your information, please refresh and try again.',
      });
      return;
    }
  }

  render() {
    const { error } = this.state;
    const title = 'Loading Loan';
    return (
      <div className="LoanHydration">
        <AppDocumentTitle title={title}>
          <FormDialog>
            <div className="LoanHydration-contentWrapper">
              {error ? (
                <ErrorMessage errorText={error!} />
              ) : (
                <div data-it="it-loading-loan">
                  <LoadingSpinner />
                  <div>Setting up your application...</div>
                </div>
              )}
            </div>
          </FormDialog>
        </AppDocumentTitle>
      </div>
    );
  }
}
